












import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import VenueLocationForm from '@ui/VenueWizard/Forms/VenueLocationForm'

settings =
  name: 'CreativeStep'

  resources:
    new_venue:
      resourceName: 'venue'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/venues/new'

    calendar_date:
      resourceName: 'calendar_date'
      slug: 'suppliers/:wizard.supplierId/audience_creatives/:audienceCreativeId/calendar_dates/:calendarDateId'
      fetch: false

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      VenueLocationForm,
    }

    computed:
      spaceId: -> @$route.query.spaceId
      calendarDateId: -> @$route.query.calendarDateId

      form: ->
        data: @prime.new_venue || {}
        errors: @formErrors.new_venue || {}

      actionsFormVenueForm: ->
        saveField: @saveField

    methods:
      saveField: ->
        venueTypes = @$store.marketplace?.listing?.venue_types || {}
        venueType = @wizard.audienceCreativeData.primary_type
        @prime.new_venue.venue_type ||= venueType if venueTypes[venueType]
        @saveItem 'prime.new_venue'

      onSave: (item) ->
        @bindVenueToResource item
        @wizard.navToStepName @step.navigation.next.to
        @$router.replace { query: { ...@$route.query, venueId: item.id } }

      onSaveError: (item) ->
        @onSave item

      bindVenueToResource: (venue) ->
        if @spaceId
          @wizard.bindVenuesToCreative [venue]
        else if @calendarDateId
          @triggerResource 'calendar_date', 'bind_venues', { venue_ids: [venue.id] }

export default VueOptions.vue settings
